import { Page } from "@/models/page-models/Page";

export const MyProductionReports: Page = {
  "path": "my-production-reports",
  "name": "My Production Reports",
  "props": {
    "data": {
      "title": "My Production Reports",
      "printable": "FALSE",
      "url": "my-production-reports",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "pendingReports",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.pendingReports}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData",
                      "label": "pendingReports",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingReports",
                      "headers": [
                        {
                          "value": "__item.shift",
                          "text": "Shift"
                        },
                        {
                          "value": "__item.process.machine",
                          "text": "Machine"
                        },
                        {
                          "value": "__item.factoryTicket.order._id",
                          "text": "Order #"
                        },
                        {
                          "value": "__item.factoryTicket._id",
                          "text": "Factory Ticket"
                        },
                        {
                          "value": "__item.factoryTicket.order.customer._id",
                          "text": "Customer",
                          "variableType": "value"
                        },
                        {
                          "value": "__item.factoryTicket.order.product",
                          "text": "Item Desc.",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.process.type",
                          "text": "Process"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 150,
                          "actions": [
                            {
                              "label": "Edit",
                              "showIf": "'{{__item.approval}}' !== 'approved'",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "openProductionReport"
                                }
                              ]
                            }
                          ],
                          "useMenu": false
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "enableSearch": true
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "approvedReports",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.approvedReports}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData",
                      "label": "approvedReports",
                      "disabled": "FALSE",
                      "items": "fetchedData.approvedReports",
                      "headers": [
                        {
                          "value": "__item.shift",
                          "text": "Shift"
                        },
                        {
                          "value": "__item.process.machine",
                          "text": "Machine"
                        },
                        {
                          "value": "__item.factoryTicket.order._id",
                          "text": "Order #"
                        },
                        {
                          "value": "__item.factoryTicket._id",
                          "text": "Factory Ticket"
                        },
                        {
                          "value": "__item.factoryTicket.order.customer._id",
                          "text": "Customer"
                        },
                        {
                          "value": "__item.factoryTicket.order.product",
                          "text": "Item Desc.",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.process.type",
                          "text": "Process"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "enableSearch": true
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getProductionReports"
      }
    ],
    "functions": [
      {
        "name": "getProductionReports",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/myproductionreports",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.productionReports",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"copyPendingReports\",\"executionOrder\":1},{\"name\":\"copyApprovedReports\",\"executionOrder\":1}]"
      },
      {
        "name": "openProductionReport",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/production-report/{{__item._id}}"
      },
      {
        "name": "filterPendingReports",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.productionReports.data",
        "arg2Key": "searchKey",
        "arg2Value": "approval",
        "arg3Key": "searchValue",
        "arg3Value": "pending"
      },
      {
        "name": "copyPendingReports",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterPendingReports",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.pendingReports"
      },
      {
        "name": "filterApprovedReports",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.productionReports.data",
        "arg2Key": "searchKey",
        "arg2Value": "approval",
        "arg3Key": "searchValue",
        "arg3Value": "approved"
      },
      {
        "name": "copyApprovedReports",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterApprovedReports",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.approvedReports"
      }
    ]
  },
  "forRole": "PRODUCTION_OPERATOR",
  "visible": true,
  "routerPriority": 50
}